import { Comment } from '@/commonTypes';
import RateComponent from '@/components/common/RateComponent';
import React, { useState } from 'react';

export default function Ratings({
  item,
  onChange,
  showAllRates = false,
  showRateTitle = false,
  width = '25px',
  className = '',
}: {
  item?: Comment;
  onChange?: (value: number, key: string) => void;
  showAllRates?: boolean;
  showRateTitle?: boolean;
  width?: string;
  className?: string;
}) {
  const initial = [
    { id: 1, title: 'امتیاز', key: 'rating' },
    { id: 2, title: 'کیفیت محصول', key: 'qualityRating' },
    { id: 3, title: 'کیفیت ارسال', key: 'deliveryRating' },
    { id: 4, title: 'اصالت محصول', key: 'originalityRating' },
  ];
  const [rateList, setRateList] = useState(showAllRates ? initial : initial?.slice(0, 1));
  console.log('rate==', item?.['rating']);
  return (
    <div className={`${className}`}>
      {rateList?.map((x, j) => (
        <RateComponent
          key={j}
          rate={item?.[x.key as keyof Comment] ? Number(item?.[x.key as keyof Comment]) : 0}
          widgetDimensions={width}
          onChange={(value: any) => {
            onChange && onChange(value, x?.key);
          }}
          number={5}
          readOnly={!onChange}
          title={showRateTitle ? x?.title : null}
        />
      ))}
    </div>
  );
}
